import { render, staticRenderFns } from "./OidcLogout.vue?vue&type=template&id=301ea588"
import script from "./OidcLogout.vue?vue&type=script&lang=js"
export * from "./OidcLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports